import { FormControl, FormLabel } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';
import { useState } from 'react';

import type { BackupVault } from '@/data/vaults/backupVault';

import { SelectVaultBucketPanel } from './selectVaultBucketPanel';

import { ChangeableTextField } from '../text/changeableTextField';

export const VaultAccountBucketSelector = ({
  data,
  setData,
  vaultAccounts,
}: {
  data: BackupVault;
  setData: (data: BackupVault) => void;
  vaultAccounts: Account[];
}) => {
  const [open, setOpen] = useState(false);

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{'Vault account and bucket'}</FormLabel>
      <ChangeableTextField
        value={data.vaultAttributes.aws?.bucketName}
        onClick={() => setOpen(true)}
        placeholder='None selected'
      />
      <SelectVaultBucketPanel
        open={open}
        onClose={() => setOpen(false)}
        disabled={false}
        data={data}
        setData={setData}
        vaultAccounts={vaultAccounts}
      />
    </FormControl>
  );
};
